import React from "react";
import TextInput from "../../Components/Inputs/TextInput";

export default function ({ register, errors }) {

    return (
        <>
            <TextInput
                label="Name"
                name="name"
                parentClasses="col-12"
                register={register}
                required={true}
                errorMessage={errors?.name}
            />

            <TextInput
              label="Position"
              name="position"
              parentClasses="col-12"
              register={register}
              errorMessage={errors?.position}
            />
        </>
    );
}